"use client";

/**
 * Last resort: only fires when the ROOT layout itself throws, which takes the
 * whole app down including Tailwind's stylesheet and every provider. Inline
 * styles and its own <html>/<body> are therefore mandatory here — nothing from
 * the app can be assumed to work.
 */
export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string };
}) {
  return (
    <html lang="es">
      <body
        style={{
          fontFamily: "system-ui, sans-serif",
          display: "flex",
          minHeight: "100vh",
          alignItems: "center",
          justifyContent: "center",
          margin: 0,
          padding: "1rem",
          background: "#f9fafb",
          color: "#111827",
          textAlign: "center",
        }}
      >
        <div style={{ maxWidth: "28rem" }}>
          <h1 style={{ fontSize: "1.5rem", marginBottom: "0.75rem" }}>
            Lo sentimos, algo salió mal
          </h1>
          <p style={{ marginBottom: "1.5rem", color: "#4b5563" }}>
            No pudimos cargar la tienda. Recarga la página para intentarlo de
            nuevo.
          </p>
          {error.digest && (
            <p style={{ fontSize: "0.75rem", color: "#9ca3af" }}>
              Código de referencia: {error.digest}
            </p>
          )}
          <button
            type="button"
            onClick={() => window.location.reload()}
            style={{
              marginTop: "1.5rem",
              padding: "0.75rem 1.5rem",
              border: 0,
              borderRadius: "0.5rem",
              background: "#05993a",
              color: "#fff",
              fontSize: "1rem",
              cursor: "pointer",
            }}
          >
            Recargar
          </button>
        </div>
      </body>
    </html>
  );
}
